import {type ChangeEventHandler, useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectEditTitle} from '~/CreateFabricInvitation/reducers/details/selectors';
import {useFormValidations} from '~/common/FabricInvitation/hooks/useFormValidations';
import {validateTitle} from '~/common/FabricInvitation/utils/validation';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {InputWithRemove} from '../InputWithRemove/InputWithRemove';

export const Title = () => {
  const ref = useRef(null);
  const dispatch = useDispatch();

  const title: string = useSelector(selectEditTitle);
  const [tempTitle, setTempTitle] = useState(title);
  const [hasError, setHasError] = useState(false);

  const updateTitle = useCallback(
    (newTitle: string) =>
      dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {title: newTitle},
      }),
    [dispatch]
  );

  const onChangeHandler: ChangeEventHandler<HTMLInputElement> = useCallback(({target: {value}}) => {
    setTempTitle(value);
    setHasError(!value?.trim()?.length);
  }, []);

  const onExitEditModeHandler = useCallback(() => {
    setTempTitle(tempTitle);
    updateTitle(tempTitle);
  }, [updateTitle, tempTitle]);

  const validate = useCallback(() => {
    const error = validateTitle(tempTitle, ref.current);
    if (error) setHasError(true);
    return error;
  }, [tempTitle]);

  useFormValidations('title', validate);

  // If a user doesn't input a Title in Step 2,
  // then on Step 4, on initial render, display the validation error
  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  useEffect(() => {
    validate();
  }, []);

  return (
    <InputWithRemove
      ref={ref}
      id="title"
      name="title"
      dataQaId="edit-eventtitle"
      error={hasError && 'Event title is required'}
      type="text"
      value={tempTitle}
      onExitEditMode={onExitEditModeHandler}
      onChange={onChangeHandler}
      showIcon={false}
      placeholder="Event Title"
      required
      maxLength={50}
      fullWidth
    />
  );
};
